import firebase from "firebase/app";
import firebaseConfig from './firebaseConfig';
require('firebase/auth');
require('firebase/firestore');
require('firebase/functions');
require('firebase/storage');

const firebaseApp = firebase.initializeApp(firebaseConfig);

export default firebaseApp.firestore();